import { getDayById } from "../services/dataService";

// TIME OVERRIDE SETTING FOR PREVIEWING/TESTING
// To use live system time, set this to null.
// To override the date, set it to a Date object, e.g., new Date("2026-06-08T20:00:00")
export const TIME_OVERRIDE: any = null; // new Date("2026-06-08T20:05:00");

export const getCurrentDate = (): Date => {
  return TIME_OVERRIDE ? new Date(TIME_OVERRIDE.getTime()) : new Date();
};

export const parsePerformanceTime = (timeStr: string, dayId?: string): Date => {
  if (timeStr.includes("-") || timeStr.includes("T")) {
    return new Date(timeStr);
  }

  let dayDate = "";
  if (dayId) {
    const day = getDayById(dayId);
    if (day) {
      dayDate = day.date;
    }
  }

  if (!dayDate) {
    const now = getCurrentDate();
    dayDate = now.toISOString().split("T")[0];
  }

  const [year, month, day] = dayDate.split("-").map(Number);
  const [hours, minutes] = timeStr.split(":").map(Number);
  const date = new Date(year, month - 1, day, hours, minutes);

  // Early morning times (00:00 to 07:59) belong to the next calendar date
  if (hours < 8) {
    date.setDate(date.getDate() + 1);
  }

  return date;
};

export const formatTime2Digit = (dateOrString: Date | string) => {
  if (typeof dateOrString === "string" && /^\d{2}:\d{2}$/.test(dateOrString)) {
    return dateOrString;
  }
  const date = typeof dateOrString === "string" ? new Date(dateOrString) : dateOrString;
  return date.toLocaleTimeString("hu-HU", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (dateOrString: string | Date) => {
  const date = typeof dateOrString === "string" ? new Date(dateOrString) : dateOrString;
  return date.toLocaleDateString("hu-HU", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatDay = (dateOrString: string | Date) => {
  const date = typeof dateOrString === "string" ? new Date(dateOrString) : dateOrString;
  return date.toLocaleDateString("hu-HU", {
    month: "short",
    day: "numeric",
  });
};

export const formatDate2Digit = (dateOrString: string | Date) => {
  const date = typeof dateOrString === "string" ? new Date(dateOrString) : dateOrString;
  return date.toLocaleDateString("hu-HU", {
    month: "2-digit",
    day: "2-digit",
  });
};

export const printDuration = (startTime: string, endTime: string, dayId?: string) => {
  const start = parsePerformanceTime(startTime, dayId);
  const end = parsePerformanceTime(endTime, dayId);
  const diff = end.getTime() - start.getTime();
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  if (hours === 0) {
    return `${minutes} perc`;
  }
  if (minutes === 0) {
    return `${hours} óra`;
  }

  return `${hours} óra ${minutes} perc`;
};
